import { IChipOption } from 'components/ChipSelect';
import React from 'react';
import { LookupChipSelect } from '../LookupChipSelect';
import { KbsGroupLookupWrapper } from 'components/Lookups/KbsGroupLookups/KbsGroupLookupWrapper';

interface IProps {
  includeDeleted?: boolean;
  selectedIds?: number[];
  onChange: (selectedOptions: readonly IChipOption[]) => void;
  placeholder?: string;
}

export const KbsGroupChipSelect = (props: IProps): JSX.Element => {
  return (
    <KbsGroupLookupWrapper includeDeleted={props.includeDeleted}>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupChipSelect
          extractLookups={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          onChange={props.onChange}
          selectedIds={props.selectedIds}
          placeholder={props.placeholder}
        />
      )}
    </KbsGroupLookupWrapper>
  );
};
